
import { computed, defineComponent } from 'vue';
import Arrow from './Arrow.vue';
import Clickable from './Clickable.vue';

export default defineComponent({
  components: {
    Arrow,
    Clickable,
  },

  props: {
    total: {
      type: Number,
      default: 1,
    },
    current: {
      type: Number,
      default: 1,
    },
    trimTo: {
      type: Number,
      default: 5,
    },
    narrowThan: {
      type: Function,
    },
  },

  emits: ['change'],

  setup(props, { emit }) {
    const effectiveTrimTo = computed(() => {
      let trimTo = props.trimTo;
      if (props.narrowThan) {
        if (props.narrowThan('sm')) {
          trimTo = Math.min(trimTo, 1);
        } else if (props.narrowThan('md')) {
          trimTo = Math.min(trimTo, 3);
        }
      }
      return trimTo;
    });

    const threshold = computed(() => Math.floor(effectiveTrimTo.value / 2));

    const start = computed(() => {
      const { current } = props;
      const trimTo = effectiveTrimTo.value;
      return current >= trimTo ? current - threshold.value : 1;
    });

    const end = computed(() => {
      const { total, current } = props;
      const trimTo = effectiveTrimTo.value;

      if (total < trimTo || current > total - trimTo) {
        return total;
      } else if (current >= trimTo) {
        return current + threshold.value;
      }

      return trimTo;
    });

    const pagesToDisplay = computed(() =>
      [...Array(end.value - start.value + 1)].map((v, i) => start.value + i),
    );

    const goTo = (index: number) => emit('change', index);

    return {
      threshold,
      start,
      end,
      pagesToDisplay,
      goTo,
    };
  },
});
